import api from './api';

export const fetchEventCupWallet = async () => {
  const res = await api.get('/api/event-cups/wallet', {
    params: { _ts: Date.now() },
    headers: {
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
    },
  });
  return res.data || {};
};

export const exchangeEventCups = async (target) => {
  const res = await api.post('/api/event-cups/exchange', { target });
  return res.data || {};
};

export const claimEventCupMilestone = async (key) => {
  const res = await api.post('/api/event-cups/claim', { key });
  return res.data || {};
};

export const fetchAdminWorldCupFestStats = async (tenantId = '') => {
  const params = { _ts: Date.now() };
  if (tenantId) params.tenant_id = tenantId;
  const res = await api.get('/api/admin/event-cups/world-cup-fest', {
    params,
    headers: {
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
    },
  });
  return res.data || {};
};
